// React bootstrap table next =>
import React, {useMemo, useRef} from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "./ui.helpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import {Card, CardBody, Pagination} from "../../../../_metronic/_partials/controls";
import {useProductsUIContext} from "../../../contexts/ProductsUIContext";
import {Button} from "react-bootstrap";

export function ProductsTable(props) {
  const context = useProductsUIContext();
  const bottomAreaRef = useRef(null);
  const {totalCount, listLoading, productList, columns} = props;

  const {
    queryParams,
    setQueryParams,
    goToCreateLink,
    onClick
  } = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
    goToCreateLink: context.goToCreateLink,
    onClick: (_, row) => context.openProductDetailDialog(row.goodsNo),
  }), [context]);

  const pagination = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  const _columns = [
    ...columns,
    {
      text: "판매 등록",
      dataField: '',
      headerClasses: 'text-center',
      classes: 'text-center',
      formatter: (_, row) => (
        <Button
          size="sm"
          variant="primary"
          onClick={(e) => goToCreateLink(e, row.goodsNo)}
        >
          판매등록
        </Button>
      ),
    }
  ]

  return (
    <Card className="mb-10">
      <CardBody>
        <PaginationProvider pagination={paginationFactory(pagination)}>
          {({paginationProps, paginationTableProps}) => (
            <Pagination isLoading={listLoading} paginationProps={paginationProps} bottomAreaRef={bottomAreaRef}>
              <BootstrapTable
                remote
                bootstrap4
                keyField="no"
                hover
                bordered={false}
                columns={_columns}
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                data={productList === null ? [] : productList}
                //defaultSorted={uiHelpers.defaultSorted}
                rowEvents={{ onClick }}
                noDataIndication={<NoRecordsFoundMessage entities={productList}/>}
                onTableChange={getHandlerTableChange(setQueryParams)}
                {...paginationTableProps}
              />
            </Pagination>
          )}
        </PaginationProvider>
      </CardBody>
    </Card>
  );
}
